import appConfig from '@/config/app';

const routes = {
	'login': '/user/login',
	'reg': '/user/register',
	'logout': '/web/member/logout',
	'verifyCode':'/web/front/verifyCode',
	'getAreaData': '/web/front/getArea',

	'accountEdit': '/member/user/editInfo',
	'password': '/web/member/passwordSet',
	'getUserInfo': '/web/member/getUserInfo', 

	'articleList': '/web/article/list',
	'articleAdd': '/web/article/addedit',
	'articleDel': '/web/article/delete',
	'articleDetail': '/web/article/detail',

	'likesList': '/web/likes/list', 
	'likesDel': '/web/likes/delete',
	
}

Object.keys(routes).forEach(key => routes[key] = `${appConfig.api.host}${routes[key]}`);

export default routes


// WEBPACK FOOTER //
// ./src/config/apiRoute.js